import Cookies from "js-cookie";

export const getLocalStorage = (name) => {
  const token = localStorage.getItem(name);

  return token;
};

export const setLocalStorage = (name, value) => {
  localStorage.setItem(name, value);

  return true;
};

export const deleteLocalStorage = (name) => {
  localStorage.removeItem(name);

  return true;
};

export const adminPasswordStandard = (password) => {
  if (
    password.length < 8 ||
    !/[A-Z]/.test(password) ||
    !/[!@#$%^&*()_+{}\[\]:;<>,.?~\-=/\\|]/.test(password)
  ) {
    return `Password must be at least 8 characters long\nPassword must contain at least one capital letter\nPassword must contain at least one symbol\n`;
  }

  return true;
};

export const emailStandard = (email) => {
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

  return emailRegex.test(email);
};

export const capitalizeFirstChar = (chars) => {
  return chars.charAt(0).toUpperCase() + chars.slice(1);
};

export const formatNumberInput = (event) => {
  if (["e", "E", "+", "-"].includes(event.key)) event.preventDefault();
};

export const setCookie = (name, value) => {
  Cookies.set(name, value, { expires: 180 });

  return true;
};

export const getCookie = (name) => {
  const cookie = Cookies.get(name);

  return cookie;
};

export const deleteCookie = (name) => {
  Cookies.remove(name);

  return true;
};
